/* Import Libs */

import 'intersection-observer';
import '../../modules/system/assets/js/framework';
import '../../modules/system/assets/js/framework.extras';
import './js/validation';
import './js/utils';
import './js/lazy-load';
import '../../node_modules/focus-visible/dist/focus-visible';


/* * Header * */
import './partials/header/userbar/userbar';

/* * Drawer * */
import './partials/header/drawer-nav/drawer-nav';
import './partials/header/search/search';
import './partials/product/cart/cart-mini/cart-mini';
import './partials/product/wish-list/wish-list';

/* * Form * */

import './partials/form/input/input';
import './partials/form/subscribe/subscribe';

/* * Other * */


/* user */

import './partials/user/login/login';


import './partials/product/cart/cart-product/cart-product';
import './partials/product/wish-list/wish-product/wish-product';
import './partials/common/wysiwyg/wysiwyg';

/* libs */
import './libs/webslidemenu/webslidemenu';

/* custom */


$('.subitem2').on('mouseenter',function(){
    $('.subitem2 .wsmegamenu').hide();
    $(this).find('.wsmegamenu').show();
});


// $('.subitem2').on('mouseleave',function(){
//     $(this).find('.wsmegamenu').hide();
// });
